export const linkedinKeys = {
  linkedin_analytics: (videoId: number) => ['LINKEDIN_ANALYTICS', videoId], // get linkedin video analytics,
  linkedin_integration_status: () => ['LINKEDIN_INTEGRATION_STATUS'],
};
